export default {"src":"/_next/static/media/fb-blue.57d3ad33.svg","height":32,"width":32};